import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toSimpleDateString } from 'src/utils/format/date';
import { makeUserUrl } from 'src/routes/routes';
import { fullName } from 'src/utils/data/user';
import s from './tableColumns.styles';

let users = [];
export const setUsers = usersItem => {
  users = usersItem;
};

export const UsersManagerColumns = () => {
  const { t } = useTranslation();

  const renderDateCell = item => {
    const link = makeUserUrl(item.entityId);
    return (
      <s.TableCellComponent>
        <s.Link to={link} withoutDelete>
          <s.Item>{toSimpleDateString(item.createdAt)}</s.Item>
        </s.Link>
      </s.TableCellComponent>
    );
  };
  const renderCell = item => {
    const link = makeUserUrl(item.entityId);
    return (
      <s.TableCellComponent>
        <s.Link to={link} withoutDelete>
          <s.EntityName to={link}>{item.entityName}</s.EntityName>
        </s.Link>
      </s.TableCellComponent>
    );
  };
  const renderUserNameCell = item => {
    const link = makeUserUrl(item.entityId);
    let user = users.find(u => +u.id === item.userId);
    if (item.userId === 0) {
      user = {
        firstName: 'Aruvio',
        lastName: 'Integration',
      };
    }
    return (
      <s.TableCellComponent>
        <s.Link to={link} withoutDelete>
          <s.Item>{user ? fullName(user) : '-'}</s.Item>
        </s.Link>
      </s.TableCellComponent>
    );
  };

  const columns = [
    {
      Header: t('COLUMN_DATE_AND_TIME'),
      id: 'created_at',
      accessor: 'createdAt',
      Cell: ({ row }) => renderDateCell(row.original),
      show: true,
    },
    {
      Header: t('COLUMN_USER_NAME_AND_SURNAME'),
      id: 'user.first_name',
      accessor: 'entityName',
      Cell: ({ row }) => renderCell(row.original),
      show: true,
      /* sortType: (a, b, fieldName) => compareData(a.original, b.original, fieldName) */
    },
    {
      Header: t('COLUMN_EDITED_BY'),
      id: 'edited_by.first_name',
      accessor: 'edited_by.first_name',
      Cell: ({ row }) => renderUserNameCell(row.original),
      show: true,
      /* sortType: (a, b, fieldName) => compareData(a.original, b.original, fieldName) */
    },
  ];

  return columns;
};
